<div class="bulk-results-summary">
  <div class="flex align-items-center gap-2 mb-3">
    <i class="pi" [ngClass]="failed().length ? 'pi-exclamation-circle p-error' : 'pi-check-circle freshgreen'" style="font-size: 1.25rem;"></i>
    <span class="font-semibold">{{ headline() }}: {{ summaryText() }}</span>
  </div>

  @if (failed().length) {
    <p class="m-0 mb-2">The following candidate{{ failed().length === 1 ? '' : 's' }} could not be processed. Re-select and retry once the issue is resolved.</p>
    <ul class="failure-list">
      @for (row of failed(); track row.name + row.error) {
        <li>
          <span class="name">{{ row.name }}</span>
          @if (row.error) {
            <span class="reason">— {{ row.error }}</span>
          }
        </li>
      }
    </ul>
  }

  <div class="flex justify-content-end mt-4">
    <p-button label="Close" [rounded]="true" (onClick)="close()"></p-button>
  </div>
</div>
